import { css, globalCSS } from 'omi';

import styles from '../../_common/style/web/components/input-number/_index.less';

export const styleSheet = css`
  ${styles}
`;

globalCSS(styleSheet);
